let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3X4zX")).then(() => parcelRequire('6EXXk'));